// extracted by mini-css-extract-plugin
export default {"modalOverlay":"AD-z","modalContent":"BD-z","header":"CD-z","close":"DD-z"};